export default __webpack_public_path__ + "static/media/23_Business-ProductArchitecture-InteriorEschweilerPhotographybebe_young_care.694db30c.jpg";